import React from 'react';

import Contact from './Contact';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import { useInView } from 'react-intersection-observer';

const FindUs = () => {

  const [ref, inView] = useInView();
  
  return (
  <div className="app__bg app__wrapper section__padding" id="contact" ref={ref}>
    <div className="app__wrapper_info">
      <SubHeading title="Got Any Queries?" />
      <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>Contact Us</h1>
      <div className="app__wrapper-content">
        <p className="p__opensans"><Contact /></p>
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>For Official Communication</p>
        <p className="mail">urja2023@thapar.edu</p>
      </div>
    </div>

    <div className="app__wrapper_img">
      <img src={images.findus} alt="finus_img" className={(inView? "srtl": "")} />
    </div>
  </div>
)};

export default FindUs;